export const pageDefaultPageNumber = 1
export const pageDefaultPageSize = 10
export const pageDefaultTotal = 0

export const userDefaultAvatar = '/static/img/my/avatar.png'
export const userDefaultNickname = '登录/注册'
